const CATEGORY_GRID_STYLES: Record<string, string> = {
  Finalizing: "excel-grid-finalizing",
  Formatting: "excel-grid-formatting",
  Charts: "excel-grid-charts",
  Modeling: "excel-grid-modeling",
  Data: "excel-grid-data",
  Utilities: "excel-grid-utilities",
  Connections: "excel-grid-connections",
  "Workflow Automation": "excel-grid-workflow",
  // Legacy support
  Cleanup: "excel-grid-finalizing",
};

export const getCategoryGradient = (category?: string | null): string => {
  return category ? CATEGORY_GRID_STYLES[category] || "excel-grid-default" : "excel-grid-default";
};
